// Utility function to extract field objects from custom_fields and default_fields in exact order
export const mapFieldsFromConfig = (
  fieldsConfig,
  customFields,
  defaultFields,
) => {
  // Convert fields_config object to array of field names in order
  const fieldOrder = Object.keys(fieldsConfig)
    .map((key) => fieldsConfig[key]);

  // Extract actual field objects in the exact order
  const orderedFieldObjects = fieldOrder
    .map((fieldName) => {
      let fieldObject = null;
      // First check in custom_fields
      fieldObject = customFields.find((field) => field.name === fieldName || field.label === fieldName);
      // If not found in custom_fields, check in default_fields
      if (!fieldObject) {
        fieldObject = defaultFields.find((field) => field.name === fieldName);
      }
      // Return the complete field object
      return fieldObject;
    })
    .filter(Boolean);

  return orderedFieldObjects;
};

// Function to get field display label
export const getFieldLabel = (field) => {
  return field.label || field.name;
};

// Function to get field type
export const getFieldType = (field) => {
  return field.type;
};

// Function to check if field is from custom_fields
export const isCustomField = (fieldName, customFields) => {
  return customFields.some((field) => field.label === fieldName);
};

// Function to get field options (for dropdown fields)
export const getFieldOptions = (field) => {
  return field.options || {};
};
